export function filterOutEmptyAndJoin(list: any[], joinBy = '\n') {
  return list.filter((value) => !!value).join(joinBy);
}
